import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { AppService } from '../../../../../../../../../../shared/services';
import { clearLocationControls } from '../../../../../../../../../../shared/helpers/design-context';

@Component({
    selector: 'app-delivery-details-form',
    templateUrl: './delivery-details-form.component.html',
    styleUrls: ['../../input-component-styles.scss', './delivery-details-form.component.scss'],
    standalone: false
})
export class DeliveryDetailsFormComponent implements OnInit, OnDestroy {
  @Input() form: FormGroup = new FormGroup({});
  @Input() selectedMediaFiles: any[] = [];
  @Input() customFields: any[] = [];
  @Input() uom: string;
  @Output() onDeletePicture: EventEmitter<void> = new EventEmitter();
  disableAddMenu = false;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    public appService: AppService,
  ) {
  }

  ngOnInit() {
  }

  deletePicture(id) {
    this.onDeletePicture.emit(id);
  }

  deleteLocation() {
    clearLocationControls(this.form, ['station_range']);
  }

  showLocationSection() {
    const hasGps = this.form?.controls?.latitude?.value !== null &&
      this.form?.controls?.longitude?.value !== null &&
      this.form?.controls?.latitude?.value !== '' &&
      this.form?.controls?.longitude?.value !== '';

    return hasGps || !!this.form?.controls?.location?.value || !!this.form?.controls?.station_range?.value;
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
